module.exports = __webpack_public_path__ + "static/media/Luna Llena (Live).f394de8c.mp3";